import { FC, useEffect } from 'react';
import { DAFCheckout } from './DAF';
import { Routes, Route, useNavigate } from 'react-router-dom';
import { getPathWithRef } from 'helpers/utils';
import { CandidateType } from 'components/Slate/Candidates/Candidates';
import { getUrlSearchParamsStrWithoutRecipients } from 'helpers/donate';

interface Props {
  candidates: CandidateType[];
  clientId: string;
  pageId: number;
  donationAmount: number;
}

export const CheckoutBase: FC<Props> = ({ candidates, donationAmount, clientId, pageId }) => {
  const navigate = useNavigate();
  useEffect(() => {
    if (!donationAmount) {
      navigate(getPathWithRef(`/donate?${getUrlSearchParamsStrWithoutRecipients()}`));
    }
  }, []);

  return (
    <Routes>
      <Route
        path="daf"
        element={
          <DAFCheckout
            candidates={candidates}
            donationAmount={donationAmount}
            clientId={clientId}
            pageId={pageId}
          />
        }
      />
      {/* Routes for future payment methods */}
    </Routes>
  );
};
